import { Vue, Options } from "vue-class-component";
import PlayerContent from "@/components/player-content.component.vue";
import ContentStat from "@/components/content-statistics.component.vue";
import SnapshotsGrid from "@/components/screenshots-grid.component.vue";
import PlayerDashboard from "@/components/player-dashboard.component.vue";
import PlayerLogs from "@/components/player-logs.component.vue";
import ModalComponent from "@/components/modal.component.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import {
    ref as storageRef,
    getStorage,
    listAll,
    getMetadata,
} from "@firebase/storage";
import moment from "moment";
import { playerPageModule } from "@/store/modules/player-page.module";
import playerSnapshotsService from "@/services/da/player-snapshots.service";
import { Unsubscribe } from "firebase/firestore";
import controlCommandsService from "@/services/da/control-commands.service";
import {playersModule} from "@/store/modules/players.module";

enum TabLinks {
    GENERAL = 'general',
    LOGS = 'logs',
    CONTENT = 'content',
    SNAPSHOTS = 'snapshots'
}

@Options({
    components: {
        PlayerContent,
        ContentStat,
        PlayerDashboard,
        PlayerLogs,
        SnapshotsGrid,
        ModalComponent,
        Datepicker,
    }
})
export default class PlayersInnerPageComponent extends Vue {

    activeTab: TabLinks = TabLinks.GENERAL

    tabLinks = TabLinks

    logs: any[] = []

    snapshots: any[] = []

    snapshotWaiting = false

    logsWaiting = false

    snapshotsListenerUnsubscribe?: Unsubscribe

    tabs = [
        {
            name: "General",
            link: TabLinks.GENERAL,
        },
        {
            name: "Logs",
            link: TabLinks.LOGS,
        },
        {
            name: "Content",
            link: TabLinks.CONTENT,
        },
        {
            name: "Snapshots",
            link: TabLinks.SNAPSHOTS,
        },
    ]

    downloadTimes = [
        { hours: 0, minutes: 0, seconds: 0 },
        { hours: 0, minutes: 0, seconds: 0 }
      ];
    downloadTimesDefault = true;

    get virtualClassesStates() {
        return playerPageModule.virtualClassesStates
    }

    get virtualClassesStateCodes() {
        return playerPageModule.virtualClassesStateCodes
    }

    get player() {
        return playerPageModule.data
    }

    changeTab(link: TabLinks) {
        if (link === TabLinks.LOGS) {
            this.logsWaiting = true
            this.loadLogs().then(() => this.logsWaiting = false)
        }
        if (link === TabLinks.SNAPSHOTS) {
            this.loadSnapshots()
        }
        this.activeTab = link
    }

    takeSnapshot() {
        controlCommandsService.takeSnapshot(this.player.Serial)
        this.snapshotWaiting = true
    }

    getLogs() {
        controlCommandsService.getLogs(this.player.Serial)
    }

    disableDownloadTimes() {
        playerPageModule.disableDownloadTimes();
    }

    enableDownloadTimes() {
        playerPageModule.enableDownloadTimes(!this.downloadTimesDefault ? this.downloadTimes : []);
    }

    onDTModalOpen(dt: any) {
        this.downloadTimes = [
            { hours: 0, minutes: 0, seconds: 0 },
            { hours: 0, minutes: 0, seconds: 0 }
        ];
        this.downloadTimesDefault = true;
    }

    private loadLogs() {
        return listAll(storageRef(getStorage(), "bsn/" + this.player.Id + "/logs"))
            .then(async (d) => {
                Promise.all(d.items.map((file) => getMetadata(file)))
                    .then((files: any[]) => {
                        files = files.sort((a: any, b: any) => {
                            return (new Date(b.timeCreated).getTime()) - (new Date(a.timeCreated).getTime())
                        }).map((file) => {
                            file.timeCreated = moment(file.timeCreated).fromNow();
                            file.updated = moment(file.updated).fromNow();
                            return file;
                        });

                        this.logs.splice(0, this.logs.length, ...files);
                    })
                    .catch((err) => console.error(err));
            }).catch((err) => console.error(err));
    }

    private loadSnapshots() {
        if (this.snapshotsListenerUnsubscribe != undefined) {
            this.snapshotsListenerUnsubscribe()
        }
        this.snapshotsListenerUnsubscribe = playerSnapshotsService.getSnaphostCollectionByPlayerId(playerPageModule.data.Id, 10,
            (querySnapshot) => {
                playerSnapshotsService.transform(querySnapshot)
                .then(snapshots => {
                    this.snapshots = snapshots.map(snapshot => {
                        const { FileUrl, ThumbUrl, MDate, createdAt } = snapshot;
                        return {
                            thumbnail: ThumbUrl,
                            source: FileUrl,
                            title: MDate,
                            id: createdAt,
                          };
                    })
                    this.snapshotWaiting = false
                })
            }, (error) => {
                console.error(error)
            }, () => console.log('complete'))
    }

    async rebootPlayers() {
        await playersModule.rebootCommand(this.player.Serial);
    }

    beforeUnmount() {
        if (this.snapshotsListenerUnsubscribe != undefined) {
            this.snapshotsListenerUnsubscribe()
        }
    }
}